import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="intersectionobserverentry" id="intersectionobserverentry"></a>
    <h1 {...{
      "id": "windowintersectionobserverentry"
    }}>{`window.IntersectionObserverEntry`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry"
      }}>{`IntersectionObserverEntry`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="new-intersectionobserverentry-new" id="new-intersectionobserverentry-new"></a>
    <h2 {...{
      "id": "intersectionobserverentryintersectionobserverentryinit"
    }}>{`IntersectionObserverEntry(intersectionObserverEntryInit)`}</h2>
    <p>{`Represents the information about the intersection of a target element with an intersection observer's root.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`intersectionObserverEntryInit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`IntersectionObserverEntryInit`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object containing the initial values for the entry.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="intersectionobserverentry-time" id="intersectionobserverentry-time"></a>
    <h2 {...{
      "id": "time--number"
    }}>{`time : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the time when the intersection was recorded. The returned value is a number and not a DOMHighResTimeStamp since DOMHighResTimeStamp is not supported in UXP.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/time"
      }}>{`IntersectionObserverEntry - time`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserverentry-rootbounds" id="intersectionobserverentry-rootbounds"></a>
    <h2 {...{
      "id": "rootbounds--domrectreadonly"
    }}>{`rootBounds : `}<inlineCode parentName="h2">{`DOMRectReadOnly`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the bounds rectangle of the root element at the time of intersection.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/rootBounds"
      }}>{`IntersectionObserverEntry - rootBounds`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserverentry-boundingclientrect" id="intersectionobserverentry-boundingclientrect"></a>
    <h2 {...{
      "id": "boundingclientrect--domrectreadonly"
    }}>{`boundingClientRect : `}<inlineCode parentName="h2">{`DOMRectReadOnly`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the target element's bounds rectangle at the time of intersection.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/boundingClientRect"
      }}>{`IntersectionObserverEntry - boundingClientRect`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserverentry-intersectionrect" id="intersectionobserverentry-intersectionrect"></a>
    <h2 {...{
      "id": "intersectionrect--domrectreadonly"
    }}>{`intersectionRect : `}<inlineCode parentName="h2">{`DOMRectReadOnly`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the rectangle describing the intersection between the target element's bounds and the root's bounds.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/intersectionRect"
      }}>{`IntersectionObserverEntry - intersectionRect`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserverentry-isintersecting" id="intersectionobserverentry-isintersecting"></a>
    <h2 {...{
      "id": "isintersecting--boolean"
    }}>{`isIntersecting : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates whether the target element is intersecting with the root.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/isIntersecting"
      }}>{`IntersectionObserverEntry - isIntersecting`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserverentry-intersectionratio" id="intersectionobserverentry-intersectionratio"></a>
    <h2 {...{
      "id": "intersectionratio--number"
    }}>{`intersectionRatio : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the ratio of the intersection area to the target element's bounding client rectangle area ranging between 0.0 and 1.0.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/intersectionRatio"
      }}>{`IntersectionObserverEntry - intersectionRatio`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserverentry-target" id="intersectionobserverentry-target"></a>
    <h2 {...{
      "id": "target--element"
    }}>{`target : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the target element being observed that has changed the amount of intersection with root.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry/target"
      }}>{`IntersectionObserverEntry - target`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      